import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import user_tracker from '../../../usertracker'
import Multiselect from 'vue-multiselect'
import {
  BasicSelect
} from 'vue-search-select'

export default {
  name: 'RestrictTempInscanonHubInScanManifestInScan',

  components: {
    VueElementLoading,
     Multiselect,
    BasicSelect
  },

  props: [],

  data() {
    return {
      hubLoading: false,
      hubdetails: [],
      isactive: true,
      tableData:false,
      userid: '',
      hubname: '',
      hubid: '',
      hubnameerror: '',
      showModal: false,
      popUpname: '',
      hubinscanlogs:[],
			isLoading: false,
			showModal: false,
			popUpname: '',
			hubLoading: '',
      insertHubDetails:false,
      hublist: [],
      hubitem: {
        value: '',
        text: ''
      },
      hubloader:'',
      isrestrictmanual:true,
      iscentrescannew:false,
      ismanifestscancheck:false,
      type: '',
      oldactivestatus : false,
      oldmanualstatus : false,
      oldcentrescanversion : false,
      oldmanifestscancheck:false,
      isrestrictreprintdirectbagsticker:false,
      oldrestrictreprintdirectbagsticker:false,
      outscanmanualrestrict: false,
      oldoutscanmanualrestrict: false,
      inscanmanualrestrict: false,
      oldinscanmanualrestrict: false,
      paperworkrestrict:false,
      oldpaperworkrestrict:false,
      centralbaggingrestrict:false,
      oldcentralbaggingrestrict:false,
      airshipmentinscan: false,
      oldairshipmentinscan: false,
      stickerprintingcontrolsrestrictions:false,
      oldstickerprintingcontrolsrestrictions:false,
      islinearflowenabledshipment: false,
      oldlinearflowshipmentstatus: false,
      islinearflowenabledbag: false,
      oldlinearflowbagstatus: false,
      oldallowotherdestinationbagout:false,
      isallowotherdestinationbagout:false, 
      isallowoverageApprovalFlag:false,
      oldisallowoverageApprovalFlag:false,
      isallowshortageApprovalFlag:false,
      oldisallowshortageApprovalFlag:false,
      isrestrictvehiclesealmanualinscan:false,
      oldrestrictvehiclesealmanualinscan:false,
      isrestrictvehiclesealmanualoutscan:false,
      oldrestrictvehiclesealmanualoutscan:false,
      isallowredirecttolmprintsticker:false,
      oldallowredirecttolmprintsticker:false,
       ismandatecompleteinboundflag : false,
      oldmandatecompleteinboundflag : false,
      isholdseal: false,
      oldisholdseal: false,
      hubnameArr:[],
      isb2bloadplanenabled:false,
      oldisb2bloadplanenabled:false,
      isreconqcenabled:false,
      oldisreconqcenabled:false,
      isredirecttolmprintforwardsticker:false,
      oldisredirecttolmprintforwardsticker:false,
      isodntcenabled:false,
      oldisodntcenabled:false,
      isodntcinboundenabled:false,
      oldisodntcinboundenabled:false,
      ismandatoryweighingflag:'disable',
      oldismandatoryweighingflag:'disable',
      isweighinginfraavailable:false,
      oldisweighinginfraavailable:false,
    }
  },

  computed: {
      // Mandatory Weighing is only editable when Weighing Infra Available is true;
    // when infra is off the value is forced to disable (mirrors backend validation).
    isMandatoryWeighingDropdownDisabled() {
      return !this.isweighinginfraavailable
    }
  },

  watch: {
    isweighinginfraavailable(newValue) {
      if (!newValue) {
        this.ismandatoryweighingflag = 'disable'
      } else if (this.ismandatoryweighingflag === 'disable') {
        // PXB-7968: mirrors backend — enabling infra defaults mandatory weighing to default.
        this.ismandatoryweighingflag = 'default'
      }
    }
  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail[0].email;
    // user_tracker.checkUserIP(userdetail[0], "AllocateHubToUser", this.$route.path);
    this.getHubList();
  },

  methods: {

    getHubList() {
      this.input = ({})
      this.hubloader = 'Loading Hub...'
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubloader = ''
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + " (" + HubDetails[i].HubID +")"

            })
          }
        }, error => {
          console.error(error)
        })
    },
    normalizeMandatoryWeighingFlag(flag) {
      const normalized = String(flag || '').trim().toLowerCase();
      if (!normalized || normalized === 'disable' || normalized === 'disabled') {
        return 'disable';
      }
      if (normalized === 'warning' || normalized === 'exception') {
        return 'exception';
      }
      if (normalized === 'enable' || normalized === 'default') {
        return 'default';
      }
      return 'disable';
    },
    getHubDetailslist(hubid) {
      this.hubLoading = true
      this.hubdetails = [];
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'fetchHubTempInscanRestrict?hubid=' + this.hubid,
          'data': {},
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = false
          if (result.data.ResultCode == 100) {
            this.hubdetails = result.data.ResponseData
            this.isactive=result.data.ResponseData[0].isactive
            this.oldactivestatus = this.isactive
            this.isrestrictmanual=result.data.ResponseData[0].isrestrictmanual
            this.oldmanualstatus = this.isrestrictmanual
            this.iscentrescannew=result.data.ResponseData[0].isenablecenterscaninnew
            this.oldcentrescanversion=this.iscentrescannew
            this.ismanifestscancheck=result.data.ResponseData[0].ismanifestscancheck
            this.oldmanifestscancheck=this.ismanifestscancheck
            this.isrestrictreprintdirectbagsticker=result.data.ResponseData[0].isrestrictreprintdirectbagsticker
            this.oldrestrictreprintdirectbagsticker=this.isrestrictreprintdirectbagsticker
            this.outscanmanualrestrict = result.data.ResponseData[0].outscanmanualrestrict
            this.oldoutscanmanualrestrict = this.outscanmanualrestrict
            this.inscanmanualrestrict = result.data.ResponseData[0].inscanmanualrestrict
            this.oldinscanmanualrestrict = this.inscanmanualrestrict
            this.paperworkrestrict = result.data.ResponseData[0].restrictpaperbagcheck
            this.oldpaperworkrestrict = this.restrictpaperbagcheck
            this.centralbaggingrestrict = result.data.ResponseData[0].issvcbagging;
            this.oldcentralbaggingrestrict = this.centralbaggingrestrict;
            this.airshipmentinscan = result.data.ResponseData[0].isrestrictairinscan;
            this.oldairshipmentinscan = this.airshipmentinscan;
            this.stickerprintingcontrolsrestrictions = result.data.ResponseData[0].stickerprintingcontrolsrestrictions;
            this.oldstickerprintingcontrolsrestrictions = this.stickerprintingcontrolsrestrictions;
            this.islinearflowenabledshipment = result.data.ResponseData[0].islinearflowenabledshipment;
            this.oldlinearflowshipmentstatus = this.islinearflowenabledshipment;
            this.islinearflowenabledbag = result.data.ResponseData[0].islinearflowenabledbag;
            this.oldlinearflowbagstatus = this.islinearflowenabledbag;
            this.isallowotherdestinationbagout = result.data.ResponseData[0].isallowotherdestinationbagout;
            this.oldallowotherdestinationbagout = this.isallowotherdestinationbagout;
            this.enablebinscanflag = result.data.ResponseData[0].merge_sec_sort_and_bagging_scan;
            this.isallowoverageApprovalFlag = result.data.ResponseData[0].isoverageapprovalflag;
            this.oldisallowoverageApprovalFlag = this.isallowoverageApprovalFlag;
            this.isallowshortageApprovalFlag = result.data.ResponseData[0].isshortageapprovalflag;
            this.oldisallowshortageApprovalFlag = this.isallowshortageApprovalFlag;
            this.oldenablebinscanflag =this.enablebinscanflag;
            this.isrestrictvehiclesealmanualinscan = result.data.ResponseData[0].isrestrictvehiclesealmanualinscan;
            this.oldrestrictvehiclesealmanualinscan = this.isrestrictvehiclesealmanualinscan;
            this.isrestrictvehiclesealmanualoutscan = result.data.ResponseData[0].isrestrictvehiclesealmanualoutscan;
            this.oldrestrictvehiclesealmanualoutscan = this.isrestrictvehiclesealmanualoutscan;
            this.isallowredirecttolmprintsticker = result.data.ResponseData[0].isallowredirecttolmprintsticker;
            this.oldallowredirecttolmprintsticker = this.isallowredirecttolmprintsticker;
            this.ismandatecompleteinboundflag = result.data.ResponseData[0].ismandatecompleteinboundflag;
            this.oldismandatecompleteinboundflag = this.ismandatecompleteinboundflag;
            this.isholdseal = result.data.ResponseData[0].isholdseal || false;
            this.oldisholdseal = this.isholdseal;
            this.isb2bloadplanenabled = result.data.ResponseData[0].isb2bloadplanenabled || false;
            this.oldisb2bloadplanenabled = this.isb2bloadplanenabled;
            this.isreconqcenabled = result.data.ResponseData[0].isreconqcenabled || false;
            this.oldisreconqcenabled = this.isreconqcenabled;
            this.ismandatoryweighingflag = this.normalizeMandatoryWeighingFlag(
              result.data.ResponseData[0].ismandatoryweighingflag
            );            this.oldismandatoryweighingflag = this.ismandatoryweighingflag;
            this.isweighinginfraavailable = result.data.ResponseData[0].isweighinginfraavailable || false;
            this.oldisweighinginfraavailable = this.isweighinginfraavailable;
            this.isredirecttolmprintforwardsticker = result.data.ResponseData[0].isredirecttolmprintforwardsticker || false;
            this.oldisredirecttolmprintforwardsticker = this.isredirecttolmprintforwardsticker;
            this.isodntcenabled = result.data.ResponseData[0].isodntcenabled || false;
            this.oldisodntcenabled = this.isodntcenabled;
            this.isodntcinboundenabled = result.data.ResponseData[0].isodntcinboundenabled || false;
            this.oldisodntcinboundenabled = this.isodntcinboundenabled;
            this.tableData=true
            
      }
         else {
            this.tableData=false
            this.insertHubDetails=true
          }
        }, error => {
          this.hubLoading = false
          console.error(error)
        })
    },

    insertHub(hubid) {
      this.hubLoading = true
      this.hubdetails = [];
      this.input = ({
      "hubid":this.hubid,
      "hubname":this.hubname,
      "createdby":this.userid})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'saveHubTempInscanRestrict',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = false
          if (result.data.ResultCode == 100) {
            this.$alertify.success("Record added successfully")
            this.getHubDetailslist(this.hubid)
          } else {
            this.$alertify.error("Record not created.")
          }
        }, error => {
          this.hubLoading = false
          console.error(error)
        })
    },

    closeinsertHubDetails() {
      this.insertHubDetails = false
    },

    setSelectedHub(hubitem) {
      this.hubid = hubitem.value;
      this.hubname = hubitem.text.split('(')[0].trim();
      this.hubitem = hubitem;
      if (this.hubname == '') {
        this.hubnameerror = 'Select Hub Name'
      } else {
        this.hubnameerror = ''
      }
    },

    clearSelectedOption() {
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hubnameerror = ''
    },

    searchHub(hubid) {
      if (hubid != '') {
        this.hubnameerror = ""
        this.getHubDetailslist(hubid);
      } else {
        this.hubnameerror = "Select Hub Name"
        return false;
      }
    },

    resetFlt() {
      this.hubname = ''
      this.hubid = ''
      this.hubnameerror = ''
      this.tableData=false,
      this.hubdetails=[];
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hubloader= '',
      this.hubnameArr=[]
    },

    allocateHub(type) {
      if (this.hubid && this.hubid != 0) {
        if(type == 1 && this.oldactivestatus == this.isactive)
        {
          this.$alertify.error(`Please update the IsActive status`)
          return false;
        } else if(type == 2 && this.oldmanualstatus == this.isrestrictmanual)
        {
          this.$alertify.error(`Please update the IsActive status`)
          return false;
        }
        else if(type == 3 && this.oldcentrescanversion == this.iscentrescannew)
        {
          this.$alertify.error(`Please update the CentreScanIn Page version`)
          return false;
        }
        else if(type == 4 && this.oldmanifestscancheck == this.ismanifestscancheck)
        {
          this.$alertify.error(`Please update the Manifest Scan check status`)
          return false;
        }
        else if(type == 5 && this.oldrestrictreprintdirectbagsticker == this.isrestrictreprintdirectbagsticker)
        {
          this.$alertify.error(`Please update the reprint sticker for direct bag status`)
          return false;
        }
        else if(type == 6 && this.oldoutscanmanualrestrict == this.outscanmanualrestrict)
        {
          this.$alertify.error(`Please update the IsActive status for Scan Out`)
          return false;
        }
        else if(type == 7 && this.oldinscanmanualrestrict == this.inscanmanualrestrict)
        {
          this.$alertify.error(`Please update the IsActive status for Scan In`)
          return false;
        }
        else if(type == 8 && this.oldpaperworkrestrict == this.paperworkrestrict)
        {
          this.$alertify.error(`Please update the IsActive status for Paper Work Restrict`)
          return false;
        }
        else if(type == 9 && this.oldcentralbaggingrestrict == this.centralbaggingrestrict)
        {
          this.$alertify.error(`Please update the IsActive status for Central Bagging`)
          return false;
        }
        else if (type == 11 && this.oldairshipmentinscan == this.airshipmentinscan) {
          this.$alertify.error(`Please update the IsActive status for Manual Air Shipment InScan`);
          return false;
        }else if (type == 12 && this.oldstickerprintingcontrolsrestrictions == this.stickerprintingcontrolsrestrictions) {
          this.$alertify.error(`Please update the IsActive status for Sticker Print`);
          return false;
        }else if (type == 13 && this.oldlinearflowshipmentstatus == this.islinearflowenabledshipment) {
          this.$alertify.error(`Please update the IsActive status for Linear Flow Shipment Movement`);
          return false;
        }else if (type == 14 && this.oldlinearflowbagstatus == this.islinearflowenabledbag) {
          this.$alertify.error(`Please update the IsActive status for Linear Flow Bag Movement`);
          return false;
        }else if (type == 15 && this.oldallowotherdestinationbagout == this.isallowotherdestinationbagout) {
          this.$alertify.error(`Please update the IsActive status for Bag out at different destination`);
          return false;
        }
        else if (type == 16 && this.oldallowredirecttolmprintsticker == this.isallowredirecttolmprintsticker) {
          this.$alertify.error(`Please update the IsActive status for Redirect To LM Print RTO/ DTO Sticker.`);
          return false;
        }
        else if (type == 17 && this.oldisallowoverageApprovalFlag == this.isallowoverageApprovalFlag) {
          this.$alertify.error(`Please update the IsActive status for Overage Approval Flag.`);
          return false;
        }else if (type == 18 && this.oldisallowshortageApprovalFlag == this.isallowshortageApprovalFlag) {
          this.$alertify.error(`Please update the IsActive status for Shortage Approval Flag.`);
          return false;
        }
        else if (type == 19 && this.oldenablebinscanflag == this.enablebinscanflag) {
          this.$alertify.error(`Please update the IsActive status for Disable Bin Scan .`);
          return false;
        }else if (type == 20 && this.oldrestrictvehiclesealmanualinscan == this.isrestrictvehiclesealmanualinscan) {
          this.$alertify.error(`Please update the IsActive status for Manual Vehicle Seal Scan In.`);
          return false;
        }else if (type == 21 && this.oldrestrictvehiclesealmanualoutscan == this.isrestrictvehiclesealmanualoutscan) {
          this.$alertify.error(`Please update the IsActive status for Manual Vehicle Seal Scan Out.`);
          return false;
        }else if (type == 22 && this.oldmandatecompleteinboundflag == this.ismandatecompleteinboundflag) {
          this.$alertify.error(`Please update the IsActive status for Complete Inbound Flag.`);
          return false;
        }else if (type == 31 && this.oldisholdseal == this.isholdseal) {
          this.$alertify.error(`Please update the IsActive status for Hold Seal Flag.`);
          return false;
        }else if (type == 24 && this.oldisb2bloadplanenabled == this.isb2bloadplanenabled) {
          this.$alertify.error(`Please update the IsActive status for B2B Load Plan.`);
          return false;
        }else if (type == 25 && this.oldisreconqcenabled == this.isreconqcenabled) {
          this.$alertify.error(`Please update the IsActive status for Recon QC.`);
          return false;
        }else if (type == 26 && this.oldismandatoryweighingflag == this.ismandatoryweighingflag) {
          this.$alertify.error(`Please update the Mandatory Weighing flag.`);
          return false;
        }else if (type == 27 && this.oldisweighinginfraavailable == this.isweighinginfraavailable) {
          this.$alertify.error(`Please update the IsActive status for Weighing Infra Available.`);
          return false;
        }else if (type == 28 && this.oldisredirecttolmprintforwardsticker == this.isredirecttolmprintforwardsticker) {
          this.$alertify.error(`Please update the IsActive status for Redirect To LM Print Forward Sticker.`);
          return false;
        }else if (type == 29 && this.oldisodntcenabled == this.isodntcenabled) {
          this.$alertify.error(`Please update the IsActive status for OD NTC Outbound.`);
          return false;
        }else if (type == 30 && this.oldisodntcinboundenabled == this.isodntcinboundenabled) {
          this.$alertify.error(`Please update the IsActive status for OD NTC Inbound.`);
          return false;
        }
        this.input = ({
          hubid: this.hubid,
          isactive: (type == 1? this.isactive:
            type == 2?this.isrestrictmanual:
            type == 3?this.iscentrescannew:
            type == 4?this.ismanifestscancheck:
            type == 5?this.isrestrictreprintdirectbagsticker:
            type == 6?this.outscanmanualrestrict:
            type == 7?this.inscanmanualrestrict:
            type == 8?this.paperworkrestrict:
            type == 9?this.centralbaggingrestrict:            
            type == 11? this.airshipmentinscan:
            type == 12 ? this.stickerprintingcontrolsrestrictions:
            type == 13 ? this.islinearflowenabledshipment:
            type == 14 ? this.islinearflowenabledbag:
            type == 15 ? this.isallowotherdestinationbagout:
            type == 16 ? this.isallowredirecttolmprintsticker:
            type == 17 ? this.isallowoverageApprovalFlag:
            type == 18 ? this.isallowshortageApprovalFlag:
            type == 19 ? this.enablebinscanflag: 
            type == 20 ? this.isrestrictvehiclesealmanualinscan:
            type == 21 ? this.isrestrictvehiclesealmanualoutscan:
            type == 22 ? this.ismandatecompleteinboundflag:
            type == 31 ? this.isholdseal:
            type == 24 ? this.isb2bloadplanenabled:
            type == 25 ? this.isreconqcenabled:
            type == 27 ? this.isweighinginfraavailable:
            type == 28 ? this.isredirecttolmprintforwardsticker:
            type == 29 ? this.isodntcenabled:
            type == 30 ? this.isodntcinboundenabled: null
            ),
          value: type == 26 ? this.ismandatoryweighingflag : undefined,
          lastmodifiedby:this.userid,
          type: type
        })

        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'updateHubTempInscanRestrict',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            let status = ''
            if(type == 1){
              this.oldactivestatus = this.isactive
             status = this.isactive?'Active':'Inactive';
            }
            else if(type == 2){
            this.oldmanualstatus = this.isrestrictmanual
            status=this.isrestrictmanual?'Active':'Inactive';
            }
            else if(type == 3)
            {
              this.oldcentrescanversion=this.iscentrescannew
              status=this.iscentrescannew?'Active':'Inactive'
            }
            else if(type == 4)
            {
              this.oldmanifestscancheck=this.ismanifestscancheck
              status=this.ismanifestscancheck?'Active':'Inactive'
            }
            else if(type == 5)
            {
              this.oldrestrictreprintdirectbagsticker=this.isrestrictreprintdirectbagsticker
              status=this.isrestrictreprintdirectbagsticker?'Active':'Inactive'
            }
            else if(type == 6)
            {
              this.oldoutscanmanualrestrict = this.outscanmanualrestrict
              status=this.outscanmanualrestrict?'Active':'Inactive'
            }
            else if(type == 7)
            {
              this.oldinscanmanualrestrict = this.inscanmanualrestrict
              status=this.inscanmanualrestrict?'Active':'Inactive'
            }
            else if(type == 8)
            {
              this.oldpaperworkrestrict = this.paperworkrestrict
              status=this.paperworkrestrict?'Active':'Inactive'
            }
            else if(type == 9)
            {
              this.oldcentralbaggingrestrict = this.centralbaggingrestrict
              status=this.centralbaggingrestrict ?'Active':'Inactive'
            }
            else if(type == 11){

              this.oldairshipmentinscan = this.airshipmentinscan;
              status = this.airshipmentinscan ? 'Active' : 'Inactive';

            }else if(type == 12){
              this.oldstickerprintingcontrolsrestrictions = this.stickerprintingcontrolsrestrictions;
              status=this.stickerprintingcontrolsrestrictions ? 'Active' : 'Inactive';
            }
            else if(type == 13){
              this.oldlinearflowshipmentstatus = this.islinearflowenabledshipment;
              status=this.islinearflowenabledshipment ? 'Active' : 'Inactive';
            }
            else if(type == 14){
              this.oldlinearflowbagstatus = this.islinearflowenabledbag;
              status=this.islinearflowenabledbag ? 'Active' : 'Inactive';
            }
            else if(type == 15){
              this.oldallowotherdestinationbagout = this.isallowotherdestinationbagout;
              status=this.isallowotherdestinationbagout ? 'Active' : 'Inactive';
            } 
            else if(type == 16){
              this.oldallowredirecttolmprintsticker = this.isallowredirecttolmprintsticker;
              status=this.isallowredirecttolmprintsticker ? 'Active' : 'Inactive';
            }
            else if(type == 17){
              this.oldisallowoverageApprovalFlag = this.isallowoverageApprovalFlag;
              status=this.isallowoverageApprovalFlag ? 'Active' : 'Inactive';
            }
            else if(type == 18){
              this.oldisallowshortageApprovalFlag = this.isallowshortageApprovalFlag;
              status=this.isallowshortageApprovalFlag ? 'Active' : 'Inactive';
            }
            else if(type == 19){
              this.oldenablebinscanflag = this.enablebinscanflag;
              status=this.enablebinscanflag ? 'Active' : 'Inactive';
            }
            else if(type == 20){
              this.oldrestrictvehiclesealmanualinscan = this.isrestrictvehiclesealmanualinscan;
              status=this.isrestrictvehiclesealmanualinscan ? 'Active' : 'Inactive';
            }
            else if(type == 21){
              this.oldrestrictvehiclesealmanualoutscan = this.isrestrictvehiclesealmanualoutscan;
              status=this.isrestrictvehiclesealmanualoutscan ? 'Active' : 'Inactive';
            }else if(type == 22){
              this.oldmandatecompleteinboundflag = this.ismandatecompleteinboundflag;
              status=this.ismandatecompleteinboundflag ? 'Active' : 'Inactive';
            }
            else if(type == 31){
              this.oldisholdseal = this.isholdseal;
              status=this.isholdseal ? 'Active' : 'Inactive';
            }else if(type == 24){
              this.oldisb2bloadplanenabled = this.isb2bloadplanenabled;
              status=this.isb2bloadplanenabled ? 'Active' : 'Inactive';
            }else if(type == 25){
              this.oldisreconqcenabled = this.isreconqcenabled;
              status=this.isreconqcenabled ? 'Active' : 'Inactive';
            }else if(type == 26){
              this.oldismandatoryweighingflag = this.ismandatoryweighingflag;
              status=this.ismandatoryweighingflag;
            }
            else if(type == 27){
                            this.oldisweighinginfraavailable = this.isweighinginfraavailable;
              status=this.isweighinginfraavailable ? 'Active' : 'Inactive';
              if (!this.isweighinginfraavailable) {
                this.ismandatoryweighingflag = 'disable';
                this.oldismandatoryweighingflag = 'disable';
              } else {
                // PXB-7968: backend cascades mandatory weighing to default when infra is enabled.
                this.ismandatoryweighingflag = 'default';
                this.oldismandatoryweighingflag = 'default';
              }
            }
            else if(type == 28){
              this.oldisredirecttolmprintforwardsticker = this.isredirecttolmprintforwardsticker;
              status=this.isredirecttolmprintforwardsticker ? 'Active' : 'Inactive';
            }else if(type == 29){
              this.oldisodntcenabled = this.isodntcenabled;
              status=this.isodntcenabled ? 'Active' : 'Inactive';
            }else if(type == 30){
              this.oldisodntcinboundenabled = this.isodntcinboundenabled;
              status=this.isodntcinboundenabled ? 'Active' : 'Inactive';
            }
            if (result.data.ResultCode == 100) {
              this.$alertify.success(`Hub is ${status} successfully`)
            }
            else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.$alertify.error("Select Hub")
      }
    },

    getLogRestrictTempHubInscan(data,type) {
			this.hubid = data.hubid;
      this.type = type
      let msg = ''
      if(type == 1){
       msg = ' Restrict Temp Inscan Logs '}
       else if(type == 8){
      msg = ' Restrict Paper Work '
      }
      else if (type == 19) {
        msg = 'Allow Disable Bin Inscan for Sort it v2 App Log ';
        }
        else if (type == 24) {
        msg = ' B2B Load Plan Logs ';
       }
       else if (type == 25) {
        msg = ' Recon QC Enabled Logs ';
       }
       else if (type == 28) {
        msg = ' Redirect To LM Print Forward Sticker Logs ';
       }
       else if (type == 29) {
        msg = ' OD NTC Outbound Enabled Logs ';
       }
       else if (type == 30) {
        msg = ' OD NTC Inbound Enabled Logs ';
       }
       else {
       msg = ' Restrict Manual Entry Logs '}
			this.popUpname = data.hubname + "(" + data.hubid + ")" +  msg

			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'fetchHubTempInscanRestrictLog?hubid=' + this.hubid +'&type=' + this.type,
					'data': {},
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.showModal = true;
						this.hubinscanlogs = result.data.ResponseData;
					} else {
						this.$alert(result.data.ReturnMessage, "", "error");
						return false;
					}
				})
		},

    closeModal() {
      this.showModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/RestrictTempInscanOnHub/RestrictTempInscanOnHub.js